/* ==========================================================================
   Richiedi preventivo — logica (nessuna libreria, namespace RQ)
   - carrello preventivi separato in localStorage (solo dati pubblici)
   - popup a due passaggi + conferma
   - accessibilità: focus trap, Escape, aria-live, ritorno focus
   ========================================================================== */
(function () {
  'use strict';

  if (window.__RQ_LOADED__) return;   // evita doppie inizializzazioni
  window.__RQ_LOADED__ = true;

  var STORAGE_KEY = 'zarrella_quote_cart_v1';
  var MAX_QTY = 9999;

  /* ----------------------------------------------------------------------
     Storage: tollerante a localStorage assente o bloccato (Safari privato)
     ---------------------------------------------------------------------- */
  var memoryFallback = null;

  function storageAvailable() {
    try {
      var k = '__rq_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) {
      return false;
    }
  }
  var hasStorage = storageAvailable();

  function readCart() {
    if (!hasStorage) return memoryFallback ? memoryFallback.slice() : [];
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeCart(items) {
    if (!hasStorage) { memoryFallback = items.slice(); return; }
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      memoryFallback = items.slice();
    }
  }

  function clearCart() {
    if (hasStorage) {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }
    memoryFallback = null;
  }

  /* ----------------------------------------------------------------------
     Utilità
     ---------------------------------------------------------------------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style: 'currency',
        currency: cur
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function clampQty(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > MAX_QTY) n = MAX_QTY;
    return n;
  }

  /* ----------------------------------------------------------------------
     Lettura del prodotto al momento del click
     ---------------------------------------------------------------------- */
  function findForm(formId) {
    if (!formId) return null;
    return document.getElementById(formId) || document.querySelector('form.' + formId);
  }

  function readVariantId(btn) {
    var formId = btn.getAttribute('data-rq-form-id');
    var form = findForm(formId);

    if (form) {
      var input = form.querySelector('input[name="id"]');
      if (input && input.value) return String(input.value);
    }
    // fallback: input collegato al form tramite attributo form=""
    var linked = document.querySelector('input[name="id"][form="' + formId + '"]');
    if (linked && linked.value) return String(linked.value);

    // fallback finale: dati del tema
    var pid = btn.getAttribute('data-rq-product-id');
    var data = window._themeProducts && window._themeProducts[pid];
    if (data && data.selected_or_first_available_variant) {
      return String(data.selected_or_first_available_variant.id);
    }
    return '';
  }

  function readQuantity(btn) {
    var formId = btn.getAttribute('data-rq-form-id');
    var form = findForm(formId);

    var qtyInput = null;
    if (form) qtyInput = form.querySelector('input[name="quantity"]');
    if (!qtyInput) qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]');

    // se il pulsante sta dentro un contenitore con il proprio selettore quantità
    if (!qtyInput) {
      var wrap = btn.closest('.m-product-form--wrapper, .m-sticky-addtocart--form');
      if (wrap) qtyInput = wrap.querySelector('input[name="quantity"]');
    }
    return qtyInput ? clampQty(qtyInput.value) : 1;
  }

  function readProduct(btn) {
    var pid = btn.getAttribute('data-rq-product-id');
    var vid = readVariantId(btn);
    var qty = readQuantity(btn);

    var title = btn.getAttribute('data-rq-product-title') || '';
    var url = btn.getAttribute('data-rq-product-url') || '';
    var image = btn.getAttribute('data-rq-product-image') || '';
    var variantTitle = '';
    var price = null;

    var data = window._themeProducts && window._themeProducts[pid];
    if (data) {
      if (!title && data.title) title = data.title;
      if (Array.isArray(data.variants)) {
        for (var i = 0; i < data.variants.length; i++) {
          var v = data.variants[i];
          if (String(v.id) === String(vid)) {
            if (v.title && v.title !== 'Default Title') variantTitle = v.title;
            if (typeof v.price === 'number') price = v.price;
            if (v.featured_image && v.featured_image.src) image = v.featured_image.src;
            else if (v.image && v.image.src) image = v.image.src;
            break;
          }
        }
      }
      if (price === null && typeof data.price === 'number') price = data.price;
      if (!url && data.handle) url = '/products/' + data.handle;
    }

    if (url && url.indexOf('http') !== 0 && vid) {
      url = url.split('?')[0] + '?variant=' + vid;
    }

    return {
      pid: String(pid || ''),
      vid: String(vid || ''),
      title: title,
      variant: variantTitle,
      image: image,
      url: url,
      qty: qty,
      price: price,
      note: ''
    };
  }

  /* ----------------------------------------------------------------------
     Operazioni sul carrello preventivi
     ---------------------------------------------------------------------- */
  function addItem(item) {
    var items = readCart();
    var merged = false;
    for (var i = 0; i < items.length; i++) {
      if (items[i].vid && item.vid && String(items[i].vid) === String(item.vid)) {
        items[i].qty = clampQty((parseInt(items[i].qty, 10) || 1) + item.qty);
        merged = true;
        break;
      }
    }
    if (!merged) items.push(item);
    writeCart(items);
    return merged;
  }

  function updateQty(vid, qty) {
    var items = readCart();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].vid) === String(vid)) { items[i].qty = clampQty(qty); break; }
    }
    writeCart(items);
  }

  function updateNote(vid, note) {
    var items = readCart();
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].vid) === String(vid)) { items[i].note = String(note || '').slice(0, 600); break; }
    }
    writeCart(items);
  }

  function removeItem(vid) {
    var items = readCart().filter(function (it) { return String(it.vid) !== String(vid); });
    writeCart(items);
  }

  /* ----------------------------------------------------------------------
     Popup
     ---------------------------------------------------------------------- */
  var modal, panel, listEl, emptyEl, summaryEl, liveEl, toStep2Btn, formEl, bodyField, errorsEl;
  var lastFocus = null;
  var currentStep = '1';
  var scrollY = 0;
  var submitted = false;

  function qs(sel) { return modal ? modal.querySelector(sel) : null; }

  function announce(msg) { if (liveEl) liveEl.textContent = msg; }

  function renderList() {
    var items = readCart();

    if (listEl) {
      listEl.innerHTML = items.map(function (it) {
        var safeVid = esc(it.vid);
        return '' +
          '<article class="rq-item" data-rq-item="' + safeVid + '">' +
            '<div class="rq-item__media">' +
              (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<div class="rq-item__main">' +
              '<h3 class="rq-item__title">' +
                (it.url ? '<a href="' + esc(it.url) + '">' + esc(it.title) + '</a>' : esc(it.title)) +
              '</h3>' +
              (it.variant ? '<span class="rq-item__variant">' + esc(it.variant) + '</span>' : '') +
              (typeof it.price === 'number' ? '<span class="rq-item__price">' + esc(money(it.price)) + '</span>' : '') +
            '</div>' +
            '<div class="rq-item__side">' +
              '<div class="rq-qty">' +
                '<button type="button" class="rq-qty__btn" data-rq-minus="' + safeVid + '" aria-label="Diminuisci quantità">&minus;</button>' +
                '<input class="rq-qty__input" type="number" min="1" inputmode="numeric" value="' + clampQty(it.qty) + '" data-rq-qty="' + safeVid + '" aria-label="Quantità">' +
                '<button type="button" class="rq-qty__btn" data-rq-plus="' + safeVid + '" aria-label="Aumenta quantità">+</button>' +
              '</div>' +
              '<button type="button" class="rq-item__remove" data-rq-remove="' + safeVid + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
                'Elimina' +
              '</button>' +
            '</div>' +
            '<div class="rq-item__note">' +
              '<label for="rq-note-' + safeVid + '">Dettagli della richiesta (misure, spessori, finitura…)</label>' +
              '<textarea class="rq-input rq-textarea" id="rq-note-' + safeVid + '" data-rq-note="' + safeVid + '" rows="2" placeholder="Es. 2000x1000 mm, spessore 3 mm">' + esc(it.note || '') + '</textarea>' +
            '</div>' +
          '</article>';
      }).join('');
    }

    if (emptyEl) emptyEl.hidden = items.length > 0;
    window.setTimeout(refreshCursors, 0);
    if (toStep2Btn) toStep2Btn.disabled = items.length === 0;

    if (summaryEl) {
      summaryEl.innerHTML = items.map(function (it) {
        return '' +
          '<div class="rq-sum-item">' +
            '<div class="rq-sum-item__media">' + (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="rq-sum-item__txt">' +
              '<div class="rq-sum-item__title">' + esc(it.title) + '</div>' +
              '<div class="rq-sum-item__meta">' + (it.variant ? esc(it.variant) + ' · ' : '') + 'Qtà ' + clampQty(it.qty) + '</div>' +
            '</div>' +
          '</div>';
      }).join('');
    }
  }

  function refreshCursors() {
    if (modal && !modal.hidden) applyCursorToChildren(true);
  }

  function setStep(step) {
    currentStep = String(step);
    var steps = modal.querySelectorAll('[data-rq-step]');
    for (var i = 0; i < steps.length; i++) {
      var isActive = steps[i].getAttribute('data-rq-step') === currentStep;
      steps[i].classList.toggle('is-active', isActive);
      steps[i].hidden = !isActive;
    }
    var dots = modal.querySelectorAll('[data-rq-step-dot]');
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-active', dots[j].getAttribute('data-rq-step-dot') === currentStep);
    }
    if (currentStep === '2') renderList();

    var focusTarget = modal.querySelector('[data-rq-step="' + currentStep + '"] input, [data-rq-step="' + currentStep + '"] button, [data-rq-step="' + currentStep + '"] textarea');
    if (focusTarget) { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }
  }

  function focusables() {
    return panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(focusables(), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  /* Il tema usa un cursore personalizzato (cursor-glow) che nasconde quello
     di sistema con regole !important. Gli stili inline con priorita' alta
     hanno la precedenza su qualsiasi foglio di stile, quindi li applichiamo
     direttamente agli elementi mentre il popup e' aperto. */
  var cursorHidden = [];

  function findCursorNodes() {
    var out = [];
    // 1) selettori noti
    var known = document.querySelectorAll(
      '.m-cursor, .m-cursor-glow, .cursor-glow, #cursor-glow, #CursorGlow, ' +
      '[data-cursor-glow], [data-cursor], .custom-cursor, .cursor-dot, .cursor-follower'
    );
    for (var i = 0; i < known.length; i++) out.push(known[i]);

    // 2) fallback: elementi fissi non interattivi con "cursor" nel nome
    var all = document.body ? document.body.children : [];
    for (var j = 0; j < all.length; j++) {
      var el = all[j];
      var name = (el.id || '') + ' ' + (el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className || '');
      if (typeof name !== 'string') continue;
      if (name.toLowerCase().indexOf('cursor') === -1) continue;
      if (out.indexOf(el) === -1) out.push(el);
    }
    return out;
  }

  function hideThemeCursor(hide) {
    if (hide) {
      cursorHidden = findCursorNodes();
      for (var i = 0; i < cursorHidden.length; i++) {
        cursorHidden[i].style.setProperty('display', 'none', 'important');
      }
      // inline + important: batte qualunque regola del tema
      document.documentElement.style.setProperty('cursor', 'auto', 'important');
      if (document.body) document.body.style.setProperty('cursor', 'auto', 'important');
      if (modal) modal.style.setProperty('cursor', 'auto', 'important');
      applyCursorToChildren(true);
    } else {
      for (var k = 0; k < cursorHidden.length; k++) {
        cursorHidden[k].style.removeProperty('display');
      }
      cursorHidden = [];
      document.documentElement.style.removeProperty('cursor');
      if (document.body) document.body.style.removeProperty('cursor');
      if (modal) modal.style.removeProperty('cursor');
      applyCursorToChildren(false);
    }
  }

  /* Assegna il cursore giusto a ogni elemento del popup, inline. */
  function applyCursorToChildren(on) {
    if (!modal) return;
    var nodes = modal.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!on) { el.style.removeProperty('cursor'); continue; }
      var tag = el.tagName;
      var value = 'auto';
      if (tag === 'A' || tag === 'BUTTON' || tag === 'LABEL' || tag === 'SELECT' || tag === 'OPTION') value = 'pointer';
      else if (tag === 'TEXTAREA') value = 'text';
      else if (tag === 'INPUT') {
        var type = (el.getAttribute('type') || 'text').toLowerCase();
        value = (type === 'checkbox' || type === 'radio' || type === 'submit' || type === 'button') ? 'pointer' : 'text';
      }
      el.style.setProperty('cursor', value, 'important');
    }
  }

  function openModal(step) {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    renderList();
    setStep(step || '1');
    // reflow, poi transizione
    void modal.offsetWidth;
    modal.classList.add('is-open');
    document.documentElement.classList.add('rq-cursor-restore');
    hideThemeCursor(true);
    document.addEventListener('keydown', onKeydown);
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('rq-cursor-restore');
    hideThemeCursor(false);
    document.removeEventListener('keydown', onKeydown);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(function () {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); }
      }
    }, reduce ? 0 : 280);
  }

  /* ----------------------------------------------------------------------
     Riepilogo testuale per contact[body]
     ---------------------------------------------------------------------- */
  function buildBody() {
    var items = readCart();
    var lines = [];
    lines.push('RICHIESTA DI PREVENTIVO');
    lines.push('');
    lines.push('PRODOTTI RICHIESTI (' + items.length + ')');
    lines.push('--------------------------------------');

    items.forEach(function (it, i) {
      lines.push((i + 1) + ') ' + (it.title || '(senza titolo)'));
      if (it.variant) lines.push('   Variante: ' + it.variant);
      lines.push('   Quantità: ' + clampQty(it.qty));
      if (typeof it.price === 'number') lines.push('   Prezzo indicativo: ' + money(it.price));
      if (it.note) lines.push('   Dettagli: ' + it.note);
      if (it.url) {
        var abs = it.url.indexOf('http') === 0 ? it.url : (window.location.origin + it.url);
        lines.push('   Link: ' + abs);
      }
      lines.push('');
    });

    var install = modal.querySelector('input[name="contact[Consegna e installazione]"]:checked');
    var msg = modal.querySelector('#rq-message');
    var company = modal.querySelector('#rq-company');
    var prefix = modal.querySelector('#rq-prefix');
    var phone = modal.querySelector('#rq-phone');

    lines.push('DATI RICHIESTA');
    lines.push('--------------------------------------');
    lines.push('Consegna e installazione: ' + (install ? install.value : 'non indicato'));
    if (company && company.value.trim()) lines.push('Azienda: ' + company.value.trim());
    if (phone && phone.value.trim()) lines.push('Telefono: ' + (prefix ? prefix.value + ' ' : '') + phone.value.trim());
    lines.push('');
    lines.push('MESSAGGIO DEL CLIENTE');
    lines.push('--------------------------------------');
    lines.push(msg && msg.value.trim() ? msg.value.trim() : '(nessun messaggio)');

    return lines.join('\n');
  }

  /* ----------------------------------------------------------------------
     Validazione step 2
     ---------------------------------------------------------------------- */
  function validate() {
    var errors = [];
    var fields = [
      { id: 'rq-first-name', label: 'Nome' },
      { id: 'rq-last-name', label: 'Cognome' },
      { id: 'rq-email', label: 'Email' },
      { id: 'rq-phone', label: 'Telefono' }
    ];

    fields.forEach(function (f) {
      var el = modal.querySelector('#' + f.id);
      if (!el) return;
      el.classList.remove('rq-invalid');
      if (!el.value.trim()) { errors.push(f.label + ' è obbligatorio.'); el.classList.add('rq-invalid'); }
    });

    var email = modal.querySelector('#rq-email');
    if (email && email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      errors.push('Inserisci un indirizzo email valido.');
      email.classList.add('rq-invalid');
    }

    if (!modal.querySelector('input[name="contact[Consegna e installazione]"]:checked')) {
      errors.push('Indica se desideri consegna e installazione.');
    }

    var privacy = modal.querySelector('#rq-privacy');
    if (privacy && !privacy.checked) errors.push('Devi accettare la privacy policy.');

    if (!readCart().length) errors.push('Aggiungi almeno un prodotto alla richiesta.');

    if (errorsEl) {
      errorsEl.innerHTML = errors.length
        ? '<ul>' + errors.map(function (e) { return '<li>' + esc(e) + '</li>'; }).join('') + '</ul>'
        : '';
    }
    if (errors.length) announce('Ci sono ' + errors.length + ' errori nel modulo.');
    return errors.length === 0;
  }

  /* ----------------------------------------------------------------------
     Binding
     ---------------------------------------------------------------------- */
  function bindModal() {
    modal = document.getElementById('rq-modal');
    if (!modal || modal.dataset.rqBound === '1') return;
    modal.dataset.rqBound = '1';

    panel = qs('.rq-modal__panel');
    listEl = qs('[data-rq-list]');
    emptyEl = qs('[data-rq-empty]');
    summaryEl = qs('[data-rq-summary]');
    liveEl = qs('[data-rq-live]');
    toStep2Btn = qs('[data-rq-to-step2]');
    formEl = qs('[data-rq-form]');
    bodyField = qs('#rq-body');
    errorsEl = qs('[data-rq-errors]');

    // chiusure
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rq-close]') || e.target.hasAttribute('data-rq-close-overlay')) {
        e.preventDefault();
        closeModal();
      }
    });

    // navigazione passaggi
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-rq-to-step2]')) {
        e.preventDefault();
        if (readCart().length) setStep('2');
      } else if (e.target.closest('[data-rq-to-step1]')) {
        e.preventDefault();
        setStep('1');
      }
    });

    // quantità, eliminazione
    modal.addEventListener('click', function (e) {
      var plus = e.target.closest('[data-rq-plus]');
      var minus = e.target.closest('[data-rq-minus]');
      var rm = e.target.closest('[data-rq-remove]');
      if (plus) {
        var vidP = plus.getAttribute('data-rq-plus');
        var inP = modal.querySelector('[data-rq-qty="' + CSS.escape(vidP) + '"]');
        var nP = clampQty((inP ? parseInt(inP.value, 10) : 1) + 1);
        updateQty(vidP, nP); renderList(); announce('Quantità aggiornata a ' + nP + '.');
      } else if (minus) {
        var vidM = minus.getAttribute('data-rq-minus');
        var inM = modal.querySelector('[data-rq-qty="' + CSS.escape(vidM) + '"]');
        var nM = clampQty((inM ? parseInt(inM.value, 10) : 2) - 1);
        updateQty(vidM, nM); renderList(); announce('Quantità aggiornata a ' + nM + '.');
      } else if (rm) {
        var vidR = rm.getAttribute('data-rq-remove');
        removeItem(vidR); renderList(); announce('Prodotto rimosso dalla richiesta.');
      }
    });

    // quantità digitata a mano + dettagli
    modal.addEventListener('change', function (e) {
      var q = e.target.closest('[data-rq-qty]');
      if (q) { updateQty(q.getAttribute('data-rq-qty'), q.value); renderList(); return; }
      var n = e.target.closest('[data-rq-note]');
      if (n) updateNote(n.getAttribute('data-rq-note'), n.value);
    });
    modal.addEventListener('input', function (e) {
      var n = e.target.closest('[data-rq-note]');
      if (n) updateNote(n.getAttribute('data-rq-note'), n.value);
    });

    // invio del form contatti nativo
    if (formEl) {
      formEl.addEventListener('submit', function (e) {
        if (submitted) { e.preventDefault(); return; }
        if (!validate()) { e.preventDefault(); return; }
        if (bodyField) bodyField.value = buildBody();
        submitted = true;
        var btn = modal.querySelector('[data-rq-submit]');
        if (btn) { btn.disabled = true; btn.textContent = 'Invio in corso…'; }
      });
    }

    // stato dopo il reload del form contatti
    var posted = modal.getAttribute('data-rq-posted');
    var hasErrors = !!modal.querySelector('[data-rq-form-errors]');

    if (posted === 'success') {
      clearCart();
      renderList();
      openModal('done');
    } else if (hasErrors) {
      openModal('2');
    }
  }

  /* ----------------------------------------------------------------------
     Pulsanti "Richiedi preventivo" (delegato: funziona anche in quick view)
     ---------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rq-open]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    if (!modal) bindModal();
    if (!modal) return;

    var item = readProduct(btn);
    if (!item.vid) {
      announce('Seleziona una variante prima di richiedere il preventivo.');
      openModal('1');
      return;
    }
    var merged = addItem(item);
    announce(merged ? 'Quantità aggiornata nella richiesta.' : 'Prodotto aggiunto alla richiesta.');
    openModal('1');
  });

  /* ----------------------------------------------------------------------
     Avvio
     ---------------------------------------------------------------------- */
  function init() { bindModal(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme Editor
  document.addEventListener('shopify:section:load', function () {
    if (modal) modal.dataset.rqBound = '';
    modal = null;
    bindModal();
  });

  // API minima, utile per debug
  window.RQQuote = {
    open: function (step) { if (!modal) bindModal(); openModal(step || '1'); },
    close: closeModal,
    getCart: readCart,
    clear: function () { clearCart(); renderList(); }
  };
})();